import { render, staticRenderFns } from "./ImportModalItem.vue?vue&type=template&id=37dfba62&"
import script from "./ImportModalItem.vue?vue&type=script&lang=ts&"
export * from "./ImportModalItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports